import React, { useEffect, useState } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import img1 from "../assets/img/favicon.png";
import "../assets/css/video-js.css";
import ReactPlayer from "react-player";
import UrlParamChecker, { UrlMobileChecker } from "../component/UrlChecker";

const Tour = (props) => {
  const [radioLanguage, setRadioLanguage] = useState("en")
  const [linkState, setLinkState] = useState("desktoplink")
  const [link, setLink] = useState('');
  const [completeData, setCompleteData] = useState("")
  const [currData, setCurrData] = useState()
  console.log("🚀 ~ Tour ~ currData:", currData)
  const device = UrlMobileChecker()
  console.log("🚀 ~ Tour ~ device:", device)



  const vid = (data) => {

    if (radioLanguage === "en") {
      if (device === "desktoplink") {
        setLink(data.desktoplink[1].url)
        setCurrData(data.desktoplink)
      }
      else if (device === "mobilelink") {
        setLink(data.mobilelink[0].url)
        setCurrData(data.mobilelink)
      }
      else if (device === "secondarymobile") {
        setLink(data.secondarymobile[0].url)
        setCurrData(data.secondarymobile)
      }
      else if (device === "primarymobile") {
        setLink(data.primarymobile[0].url)
        setCurrData(data.primarymobile)
      }

    }
    else {
      setLink(data.desktoplink[0].url)
      setCurrData(data.desktoplink)
    }
    // else if (radioLanguage === "hi") {
    //   if (linkState === "hiDesktopLink") { }
    //   else if (linkState === "hiMobileLink") { }
    //   else if (linkState === "hiSecondaryMobile") { }
    //   else if (linkState === "hiPrimaryMobile") { }

    // }
  }



  const handleLinkState = (data) => {

    if (data === "desktoplink") {
      setLinkState("desktoplink")
      if (radioLanguage === "hi") { setCurrData(completeData.hidesktoplink) }
      else if (radioLanguage === "en") { setCurrData(completeData.desktoplink) }
    }
    else if (data === "mobilelink") {
      setLinkState("mobilelink")
      if (completeData.himobilelink?.length > 0 && radioLanguage === "hi") { setCurrData(completeData.himobilelink) }


      else if (radioLanguage === "en") { setCurrData(completeData.mobilelink) }
      else {
        setRadioLanguage("en")
        setCurrData(completeData.mobilelink)
      }
    }

  }

  const handleLanguageChange = (data) => {

    setRadioLanguage(data)
    if (data === "hi") {
      if (linkState === "desktoplink") { setCurrData(completeData.hidesktoplink) }
      else if (linkState === "mobilelink") { setCurrData(completeData.himobilelink) }
      else if (linkState === "secondarymobile") { setCurrData(completeData.hisecondarymobile) }
      else if (linkState === "primarymobile") { setCurrData(completeData.hiprimarymobile) }
    }
    else if (data === "en") {
      if (linkState === "desktoplink") { setCurrData(completeData.desktoplink) }
      else if (linkState === "mobilelink") { setCurrData(completeData.mobilelink) }
      else if (linkState === "secondarymobile") { setCurrData(completeData.secondarymobile) }
      else if (linkState === "primarymobile") { setCurrData(completeData.primarymobile) }
    }
  }

  console.log(currData)
  useEffect(() => {
    setLinkState(device)
    window.scrollTo(0, 0);
    fetch(`/app/videoData.json`)
      .then((res) => {
        return res.json()
      }).then((data) => {
        setCompleteData(data)
        vid(data)
      }).catch(err => console.log(err));

  }, []);




  const mobileChecker = () => {
    if (linkState === "mobilelink" || linkState === "primarymobile" || linkState === "secondarymobile") return false
    else return true
  }
  const priSecChecker = () => {
    if (["primarymobile", "secondarymobile", "hiPrimaryMobile", "hiSecondaryMobile"].includes(linkState)) return false
    else return true
  }
  const desktopChecker = () => {
    if (linkState === "desktoplink") return false
    else return true
  }
  let data = [
    {
      url: "https://rbiretaildirect.org.in/common/videos/PMO-RD-Launch.mp4",
      thumbnail: { img1 },
      isLive: false,
      header: "RBI Retail Direct",
      title: "Inauguration by Hon'ble PM of India",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Introduction.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      title: "Introduction",
      length: "",
      playing: true,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Bond Basics.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "Bond Basics",
      title: "Bond Basics",
      length: "0:15",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Types of G-Secs.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Types of G-Secs",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Factors Affecting G-Sec Prices.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Factors Affecting G-Sec Prices",
      length: "0:15",
      playing: false,
    },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/G-Sec Returns.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "G-Sec Returns",
    //   length: "10:53",
    //   playing: false,
    // },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/Price Yield Relationship.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "Price Yield Relationship",
    //   length: "10:53",
    //   playing: false,
    // },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Pricing of G-Secs.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "Pricing of G-Secs - Part 1",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Pricing of G-Secs-2.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "Pricing of G-Secs - Part 2",
      length: "10:53",
      playing: false,
    },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/Risks on G-Secs.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "Risks on G-Secs",
    //   length: "10:53",
    //   playing: false,
    // },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Concept of interest rates.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Concept of Interest Rates",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Yield Curves.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Yield Curves",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to do KYC.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "Primary Market",
      title: "How to KYC",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to login to account.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to Login",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to Bid",
      length: "0:15",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to fund a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to fund a Bid",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to amend a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to amend a Bid",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to withdraw a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "How to withdraw a Bid",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view allotment.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Allotment",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view holdings.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Holdings",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view recent auctions.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Recent Auctions",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to check coupon data.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Coupon Data",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view redemptions.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Redemptions",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view transaction history.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Transaction History",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to check fund activity log.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Funds Activity Log",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-nds-om-access-request.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "Secondary Market",
      title: "How to register for NDS OM",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-add-mw.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to set your Market Watch",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-order.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to place an Order",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-rfq.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to place a RFQ Quote",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-ytm.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to use the YTM Calculator ",
      length: "10:53",
      playing: false,
    },
  ];
  let mobiledata = [

    {
      url: 'https://rbiretaildirect.org.in/common/videos/Introduction.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "RBI Retail Direct",
      title: "Introduction",
      length: "",
      playing: true,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Introduction Mobile App.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      title: "Introduction - Mobile App",
      length: "",
      playing: true,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/App Walkthrough - Primary.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "Primary Market",
      title: "App Walkthrough",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to complete KYC process - V4.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to complete KYC process",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to login - V2.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to login",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to Place Modify Withdraw Bids_V2.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to Place Modify Withdraw Bids",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Primary-Fund Placed Bids.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to Fund Bids",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view Portfolio - V2.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Portfolio",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Transaction_Fund_Activity log - V3.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Transaction Fund Activity Log",
      length: "",
      playing: false,
    },

    {
      url: 'https://rbiretaildirect.org.in/common/videos/App Walkthrough - sec.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "Secondary Market",
      title: "App Walkthrough",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to Login_ NDS-OM App - V3.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to Login",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Secondary-Market Watch.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Market Watch",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to place order - V4.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to place order",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to place RFQ Quote V2.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to place RFQ Quote",
      length: "",
      playing: false,
    },

  ];
  let hiData = [
    {
      // url: "https://pmindiawebcast.nic.in/player/vod/pmevents/media/pm12nov21.mp4",
      thumbnail: { img1 },
      isLive: false,
      header: "आरबीआई रिटेल डायरेक्ट",
      title: "भारत के माननीय प्रधान मंत्री द्वारा उद्घाटन",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Introduction.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      title: "परिचय",
      length: "",
      playing: true,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Bond Basics.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "बॉन्ड मूल बातें",
      title: "बॉन्ड मूल बातें",
      length: "0:15",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Types of G-Secs.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "जी-सेक के प्रकार",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Factors Affecting G-Sec Prices.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "जी-सेक कीमतों को प्रभावित करने वाले कारक",
      length: "0:15",
      playing: false,
    },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/G-Sec Returns.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "जी-सेक रिटर्न",
    //   length: "10:53",
    //   playing: false,
    // },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/Price Yield Relationship.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "मूल्य उपज संबंध",
    //   length: "10:53",
    //   playing: false,
    // },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Pricing of G-Secs.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "जी-सेकेंड की कीमत  - भाग 1",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Pricing of G-Secs-2.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "जी-सेकेंड की कीमत - भाग 2",
      length: "10:53",
      playing: false,
    },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/Risks on G-Secs.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "जी-सेक पर जोखिम",
    //   length: "10:53",
    //   playing: false,
    // },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Concept of interest rates.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ब्याज दरों की संकल्पना",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Yield Curves.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "उपज घटता",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to do KYC.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "प्राइमरी मार्केट",
      title: "KYC कैसे करें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to login to account.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "लॉग इन कैसे करें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "बोली कैसे लगाएं",
      length: "0:15",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to fund a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "बोली कैसे फंड करें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to amend a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "बोली में संशोधन कैसे करें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to withdraw a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "बोली कैसे वापस लें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view allotment.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "अलॉटमेंट कैसे देखें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view holdings.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "होल्डिंग्स को कैसे देखें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view recent auctions.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "हाल की नीलामी कैसे देखें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to check coupon data.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "कूपन डेटा कैसे देखें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view redemptions.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "मोचन कैसे देखें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view transaction history.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "लेन-देन इतिहास कैसे देखें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to check fund activity log.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "फंड गतिविधि लॉग कैसे देखें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-nds-om-access-request.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "सेकेंडरी मार्केट",
      title: "NDS OM के लिए पंजीकरण कैसे करें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-add-mw.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "अपनी मार्केट वॉच कैसे सेट करें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-order.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ऑर्डर कैसे करें",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-rfq.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "RFQ कोट कैसे लगाएं",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-ytm.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "YTM कैलकुलेटर का उपयोग कैसे करें",
      length: "10:53",
      playing: false,
    },
  ];
  const videoData = () => {
    if (mobileChecker() && radioLanguage === "en") return currData?.mobilelink
    else if (desktopChecker() && radioLanguage === "en") return currData?.desktoplink
    else if (desktopChecker() && radioLanguage === "hi") return currData?.desktoplink
    else return currData?.desktoplink
  }







  const videoAvailabiltyChecker = (data) => {

    if (['primarymobile'].includes(device) && (completeData.primarymobile?.length === 0 || completeData.hiprimarymobile?.length === 0)) return false
    else if (['secondarymobile'].includes(device) && (completeData.secondarymobile?.length === 0 || completeData.hisecondarymobile?.length === 0)) return false
    else if (['mobilelink'].includes(linkState) && (completeData.mobilelink?.length === 0 || completeData.himobilelink?.length === 0)) return false
    else return true

  }
  const finalData = currData

  let last_video_index = 0;

  const changeVideo = (s) => {
    if (s.url) {
      finalData[last_video_index].playing = false;
      last_video_index = finalData.indexOf(s);
      finalData[last_video_index].playing = true;
      setLink(s.url);
    }

  };



  return (
    <div>
      <NavBar />
      <main id="main">
        <section id="tour" className="innerPage" style={UrlParamChecker() ? { marginTop: "16px", paddingTop: "0" } : {}}>
          <div className="container">
            <div className="section-title d-flex justify-content-between ">
              <h2>Guided Tours</h2>
              <div className="text-nowrap">






                {videoAvailabiltyChecker() && <div class="btn-group btn-sm btn-group-toggle " data-toggle="buttons">
                  <label
                    class={` btn btn-sm ${radioLanguage === "en" ? "custom-switch-btn-pm" : "custom-switch-btn-sc"}  `}>
                    <input class="langToggle" onClick={() => handleLanguageChange("en")} type="radio" name="options" id="enLang" value="en" checked={radioLanguage === "en"} /> English
                  </label>
                  <label class={`btn btn-sm ${radioLanguage === "hi" ? "custom-switch-btn-pm" : "custom-switch-btn-sc"} `}>
                    <input class="langToggle" onClick={() => handleLanguageChange("hi")} type="radio" name="options" id="hiLang" value="hi" checked={radioLanguage === "hi"} /> हिंदी
                  </label>
                </div>}


                {priSecChecker() && <div class="btn-group btn-sm btn-group-toggle" data-toggle="buttons">
                  <label class={`btn btn-sm ${!mobileChecker() ? "custom-switch-btn-pm" : "custom-switch-btn-sc"}`}>
                    <input onClick={(e) => handleLinkState(e.target.value)} type="radio" name="options" id="mobilelink" value="mobilelink" checked={!mobileChecker()} /> Mobile
                  </label>
                  <label class={`btn btn-sm ${!desktopChecker() ? "custom-switch-btn-pm" : "custom-switch-btn-sc"}`}>
                    <input onClick={(e) => handleLinkState(e.target.value)} type="radio" name="options" id="desktoplink" value="desktoplink" checked={!desktopChecker()} /> Web
                  </label>
                </div>}
              </div>

            </div>
            {/* <div className="text-right mx-2 pb-4">
              <span className="mx-2" onClick={() => setRadioLanguage("en")}>
                <input className="mx-1" type="radio" checked={radioLanguage === "en"}></input><label>English</label></span>
              <span className="mx-2" onClick={() => setRadioLanguage("hi")}>
                <input className="mx-1" type="radio" checked={radioLanguage === "hi"}></input><label>Hindi</label></span>

            </div> */}
            <div className="row page-wrapper">
              <div className="col-lg-8">
                <div className="playlist-wrapper">
                  <div className="playlist-mother-video">
                    <ReactPlayer
                      url={link}
                      muted={false}
                      playing={true}
                      controls={true}
                      config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                      className="video-dimension"
                      style={{ maxWidth: '100%' }}
                    />
                  </div>
                  <div className="playlist-products"></div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="playlist-child-videos" id="plylst_upcming">
                  {finalData && finalData.map((data, index) => (
                    <div
                      key={index}
                      className="playlist-item-wrapper"
                      data-playing={data.playing.toString()}
                      data-live={data.isLive.toString()}
                      onClick={() => changeVideo(data)}
                    >
                      <div
                        className="playlist-thumb"
                        style={{ display: "none" }}
                      >
                        <img src={data.thumbnail} />
                        <div className="playlist-meta-length">
                          <span>{data.isLive ? "Live" : data.length}</span>
                        </div>
                      </div>
                      <div className="playlist-meta">
                        <h5 className="playlist-meta-header">{data.header}</h5>
                        <a className="playlist-meta-title">
                          <i className="ri-video-line"></i>
                          {data.title}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer footerClass="footerFixed" />
    </div>
  );
};

export default Tour;
